/**
 * Created with IntelliJ IDEA.
 * User: bkolve
 * Date: 08.07.13
 * Time: 12:14
 * To change this template use File | Settings | File Templates.
 */
export class HTMLEscaper {

    public static unescape(str: string): string {
        // TODO: @HTML5 remove all HTML entities
        // String will be transformed to the XMLDocument to filter all html entities.
        // let result: string = new XMLDocument(str).firstChild.nodeValue;
        let result: string = str;

        result.replace(/(<([^>]+)>)/ig, "");

        // We need to filter some values manually("&percnt;%20" etc).
        result = result.split("&percnt;20").join(" ").split(";").join(" ");

        return result;
    }

    public static escape(str: string): string {
        // TODO: @HTML5 find a way to replace the behaviour of toXMLString method
        // return XML(new XMLNode(XMLNodeType.TEXT_NODE, str)).toXMLString();
        return str;
    }
}
